var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsActionTalk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#EEF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3511 36.087C26.4677 33.8593 23.1349 33.5802 20.9072 35.4636C18.6794 37.347 18.4003 40.6798 20.2838 42.9075L28.2782 52.3633C30.1616 54.591 33.4944 54.8702 35.7221 52.9867C37.9498 51.1033 38.2289 47.7705 36.3455 45.5428L28.3511 36.087Z",
    fill: "#60C2A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0608 22.7342C51.7484 22.0466 52.8632 22.0466 53.5508 22.7342C56.9888 26.1721 56.9888 31.7462 53.5508 35.1842L36.1778 52.5572C34.115 54.62 30.7705 54.62 28.7078 52.5572C26.645 50.4944 26.645 47.15 28.7078 45.0872L51.0608 22.7342Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsActionTalk);
export default __webpack_public_path__ + "static/media/results-action-talk.16b9eb2ba032d5e0bd8de42acae88825.svg";
export { ForwardRef as ReactComponent };